@if (user(); as user) {
  <button mat-mini-fab [matMenuTriggerFor]="profile">
    @if (user.photo) {
      <div class="pfp">
        <img [src]="sanitizeUrl(user.photo)" />
      </div>
    }
    @else {
      <span>{{ user.firstName!.charAt(0) + (user.lastName!.charAt(0)) }}</span>
    }
  </button>

  <mat-menu #profile>
    <div class="profile-menu">
      <div class="profile-menu-content">
        <div class="profile-menu-photo">
          @if (user.photo) {
            <img [src]="sanitizeUrl(user.photo)" />
          }
          @else {
            <mat-icon>badge</mat-icon>
          }
        </div>
        <div>
          <div style="font-size:large"><strong>{{ user.firstName + ' ' + user.lastName }}</strong></div>
          <div>{{user.emailAddress}}</div>
          <div>{{user.jobTitle}}</div>
          <div>{{user.office}}</div>
          @if(user.isAdminUser) {
            <div><strong>System Admin</strong></div>
          }
        </div>
      </div>
      <button mat-flat-button (click)="logout()" color="primary">Logout</button>
    </div>
  </mat-menu>
}
@else {
  <button mat-mini-fab>
    <span>ME</span>
  </button>
}
